import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import {
  User,
  APIResponse,
  BluePrintRole,
  Role,
  Division,
  AddUserData,
  EditUserData
} from '../models';

import { ApiService } from './api.service';

@Injectable()
export class RoleService {
  constructor(private http: Http, private apiService: ApiService) {}

  addRole(data: BluePrintRole): Observable<APIResponse<any, any>> {
    return this.apiService.post('/role/add', data);
  }

  editRole(data: Role): Observable<APIResponse<any, any>> {
    return this.apiService.put('/role/edit', data);
  }

  deleteRole(updatedata: string): Observable<APIResponse<any, any>> {
    return this.apiService.delete('/role/delete/' + updatedata);
  }

  getRoles(): Observable<APIResponse<Role[], any>> {
    return this.apiService.get('/roles');
  }

  addMember(data: User[]): Observable<APIResponse<User[], any>> {
    return this.apiService.post('/role/member/add', data);
  }

  removeMember(data: User[]): Observable<APIResponse<User[], any>> {
    return this.apiService.post('/role/member/remove', data);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/role.service.ts